export const defaultAvatar =
    "https://static-00.iconduck.com/assets.00/avatar-default-symbolic-icon-2048x1949-pq9uiebg.png";

// IOS device can only support H.264 video up to 720p, 30fps, 160Kbps, 48kHZ stereo audio
export const bgVideo =
    "https://firebasestorage.googleapis.com/v0/b/stork-69d6e.appspot.com/o/ocean.mp4?alt=media&token=8bc79c13-db27-40ad-91d3-a2d4f1225d6b";
